import { render, staticRenderFns } from "./TrainingSeoList.vue?vue&type=template&id=918dd09c&"
import script from "./TrainingSeoList.vue?vue&type=script&lang=js&"
export * from "./TrainingSeoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports